import axios from 'axios'
import {
  Message
} from 'element-ui'
import qs from 'qs'
import store from '@/store'
import {
  getToken,
  getTokenRequest
} from '@/utils/auth'
import router from '@/router'
import { refreshToken } from '@/api/identityApi'
import { getUTCTime } from '@/utils/date.js'
import jwt_decode from 'jwt-decode'
import { logoutFn } from '@/utils/logout'
import { mgr } from '@/utils/oidc'
import { objChangeOrderMap } from '@/utils/goodsFile/goodsFile.js'
import { deriveHttpsBaseURLFromLocation, getEnvUrlPathname } from '@/utils/runtimeBaseUrl'

const AUTH_DEBUG_IFRAME_STORAGE_KEY = 'OAK_AUTH_DEBUG_IFRAME_DATA'
const AUTH_DEBUG_IFRAME_DATA_MAX_AGE = 60 * 2000
let iframeData = readAuthorizationDebugIframeData()
// token刷新的处理
let isRefreshing = false
// // 重试队列
let requests = []
const oidcStatus = process.env.NODE_ENV === 'development'

window.addEventListener('message', getVueMsg)

function getVueMsg(event) {
  const res = event.data
  if (res.cmd === 'myIframe') {
    iframeData = res.params
    console.log('[AuthorizationDebug][iframe-request] receive debug token by postMessage', {
      authorizationCode: iframeData.authorizationCode,
      hasToken: !!iframeData.token
    })
  }
}

function isInIframe() {
  try {
    return window.self !== window.top
  } catch (error) {
    return true
  }
}

function readAuthorizationDebugIframeData() {
  if (!isInIframe()) {
    return {}
  }
  try {
    const rawData = localStorage.getItem(AUTH_DEBUG_IFRAME_STORAGE_KEY)
    const debugData = rawData ? JSON.parse(rawData) : {}
    if (debugData.token) {
      const dataAge = new Date().getTime() - Number(debugData.createdAt || 0)
      if (dataAge > AUTH_DEBUG_IFRAME_DATA_MAX_AGE) {
        localStorage.removeItem(AUTH_DEBUG_IFRAME_STORAGE_KEY)
        console.warn('[AuthorizationDebug][iframe-request] startup debug token expired', {
          authorizationCode: debugData.authorizationCode,
          createdAt: debugData.createdAt,
          dataAge
        })
        return {}
      }
      console.log('[AuthorizationDebug][iframe-request] read startup debug token', {
        authorizationCode: debugData.authorizationCode,
        createdAt: debugData.createdAt,
        dataAge
      })
    } else {
      console.warn('[AuthorizationDebug][iframe-request] startup debug token missing')
    }
    return debugData
  } catch (error) {
    console.error('[AuthorizationDebug][iframe-request] read startup debug token failed', error)
    return {}
  }
}

// 处理报错问题
function errorFn(response) {
  if (response.data.res_status_code === '2000') {
    Message({
      message: response.data.res_message,
      type: 'error',
      duration: 5 * 1000
    })
    const token = localStorage.getItem('access_token')
    if (token) {
      logoutFn()
    } else {
      location.reload()
    }
  }
  if (response.data.res_status_code === '2001') {
    window.location.href = process.env.ERROE_HTML_URL
  }
}
// 获取到token
function getTokenRefHandle() {
  const token = localStorage.getItem('access_token')
  return token
}
// create an axios instance
const service = axios.create({
  baseURL: (() => {
    const derived = deriveHttpsBaseURLFromLocation({
      pathname: getEnvUrlPathname(process.env.BASE_API, '/api/')
    })

    // existing override mechanism (used by dev/sit) still has highest priority
    if (process.env.ENV_CONFIG === 'dev' || process.env.ENV_CONFIG === 'sit') {
      try {
        const v = JSON.parse(localStorage.getItem('baseApiData'))
        if (v && v.api_address) return v.api_address
      } catch (e) {
        // ignore invalid localStorage payload
      }
    }

    return derived || process.env.BASE_API
  })() // api 的 base_url
  // timeout: 5000 // request timeout
})
const pending = []
const CancelToken = axios.CancelToken
const cancelPending = config => {
  pending.forEach((item, index) => {
    if (config) {
      if (item.UrlPath === config.url) {
        item.Cancel() // 取消请求
        pending.splice(index, 1) // 移除当前请求记录
      }
    } else {
      item.Cancel() // 取消请求
      pending.splice(index, 1) // 移除当前请求记录
    }
  })
}

// request interceptor
service.interceptors.request.use(
  config => {
    if (localStorage.getItem('J-Session-ID')) {
      const J_Session_ID = localStorage.getItem('J-Session-ID')
      config.headers['J-Session-ID'] = `${J_Session_ID}`
    }

    // 旧 token 头暂不可用，开发环境也走 access_token（Bearer）
    if (oidcStatus) {
      const token = localStorage.getItem('access_token')
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
      }
    } else {
      // 判断token是否过期
      /*
          1.过期
          2.刷新标识
        */
      // 是否刷新中
      const tokenObj = JSON.parse(localStorage.getItem('tokenObj') || '0')
      const currentTime = getUTCTime() / 1000
      if (getTokenRefHandle() && !isRefreshing && Number(tokenObj.expires_at) < (Number(currentTime) + 600)) {
        // 设置刷新状态
        isRefreshing = true
        const client_secret = process.env.BASE_OIDC_WEB_CLIENT_SECRET
        const client_id = process.env.NODE_ENV === 'sit' ? 'js_oak_vue_uat' : 'js_oak_vue'
        // 调用刷新接口
        const loginParams = {
          client_id: client_id,
          grant_type: 'refresh_token',
          client_secret: client_secret,
          refresh_token: tokenObj.refresh_token,
          scope: 'api openid profile offline_access'
        }
        refreshToken(loginParams).then(res => {
          // 已经刷新token了，将所有队列中的请求进行重试
          const jwtToken = jwt_decode(res.data.access_token)
          const tokenObj = {
            expires_at: jwtToken.exp,
            refresh_token: res.data.refresh_token,
            loginIn: jwtToken.lid
          }
          localStorage.setItem('access_token', res.data.access_token)
          localStorage.setItem('tokenObj', JSON.stringify(tokenObj))
          // 更新刷新的token缓存数据
          isRefreshing = false
          requests.forEach(cb => cb(res.data.access_token))
          requests = []
        }).catch(() => {
          localStorage.clear()
          mgr.signinRedirect({ state: window.location.href })
        })
      }
      if (isRefreshing && config.url !== 'connect/token') {
        const res = new Promise((resolve) => {
          requests.push((token) => {
            config.headers['Authorization'] = `Bearer ${token}`
            resolve(config)
          })
        })
        return res
      }
      // Do something before request is sent
      const token = localStorage.getItem('access_token')
      if (token && !iframeData.token) {
        config.headers['Authorization'] = `Bearer ${token}`
      }
    }
    const header_route = encodeURI(router.app._route.meta.title)
    if (getTokenRequest()) {
      config.headers['request_token'] = getTokenRequest()
    }
    if (iframeData.token) {
      // 授权人凭证：不再写 token 头，改走 access_token / Authorization
      config.headers['Authorization'] = `Bearer ${iframeData.token}`
      config.headers['authorizationcode'] = iframeData.authorizationCode // 调试码
      console.log('[AuthorizationDebug][iframe-request] apply debug token', {
        url: config.url,
        authorizationCode: iframeData.authorizationCode
      })
      const debuggerToken = getToken() || getTokenRefHandle()
      if (debuggerToken && debuggerToken !== iframeData.token) {
        config.headers['debugtoken'] = debuggerToken
      }
    } else if (store.getters.token) {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      // config.headers['token'] = getToken()
    }
    config.headers['router'] = header_route

    // 财务归档环境处理 - 添加ArchiveTag请求头 同时排除GetFunction接口
    var isArchiveEnv = sessionStorage.getItem('isArchiveEnv')
    if (isArchiveEnv === 'true' && config.url.indexOf('GetFunction') < 0) {
      config.headers['ArchiveTag'] = 1
      console.log('[归档环境] 请求拦截器 - 已添加ArchiveTag请求头:', config.url)
    }

    getPageUrl(config, router)
    // 新增后端使用文件流返回文件
    if (
      config.url === 'doc/Documents/ExportDocumentList' ||
      config.url.indexOf('ExportDocumentList') > -1 ||
      config.url.indexOf('exportDocumentList') > -1 ||
      config.url.indexOf('/Query/ExportList') > -1 ||
      config.url.indexOf('/Query/exportList') > -1 ||
      config.url.indexOf('/MouldOrder/GetMouldExportList') > -1 ||
      config.url.indexOf('maple/MapleStatement/ExportStatementsList') > -1 ||
      config.url.indexOf('celeb/PromoteFinanceReport/ExportBusinessList') > -1
    ) {
      config['responseType'] = 'blob' // 服务请求类型
    }

    if (config.params) {
      // isCancelRequest : 1：需要取消上次请求
      if (Object.prototype.hasOwnProperty.call(config.params, 'isCancelRequest')) {
        if (config.params.isCancelRequest === 1) {
          cancelPending(config)
          config.cancelToken = new CancelToken(res => {
            pending.push({
              UrlPath: config.url,
              Cancel: res
            })
          })
        }
      }
      if (config.isStringfy && config.method.toLocaleLowerCase() === 'get') {
        config.paramsSerializer = function(params) {
          return qs.stringify(params, {
            arrayFormat: 'repeat'
          })
        }
      }
    }

    return config
  },
  error => {
    // Do something with request error
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    cancelPending(response.config)
    const arr = ['2000', '2001']
    if (arr.includes(response.data.res_status_code)) {
      errorFn(response)
    } else {
      return response
    }
  },
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  // response => {
  //   const res = response.data
  //   if (res.code !== 20000) {
  //     Message({
  //       message: res.message,
  //       type: 'error',
  //       duration: 5 * 1000
  //     })
  //     // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
  //     if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //       // 请自行在引入 MessageBox
  //       // import { Message, MessageBox } from 'element-ui'
  //       MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
  //         confirmButtonText: '重新登录',
  //         cancelButtonText: '取消',
  //         type: 'warning'
  //       }).then(() => {
  //         store.dispatch('FedLogOut').then(() => {
  //           location.reload() // 为了重新实例化vue-router对象 避免bug
  //         })
  //       })
  //     }
  //     return Promise.reject('error')
  //   } else {
  //     return response.data
  //   }
  // },
  error => {
    if (error.response && !error.response.config.isError && error.response.data.res_message) {
      Message({
        message: error.response.data.res_message,
        type: 'error',
        duration: 5 * 1000
      })
      const arr = ['2000', '2001']
      if (arr.includes(error.response.data.res_status_code)) {
        errorFn(error.response)
      }
    }
    return Promise.reject(error)
  }
)

export default service

// 主数据权限处理方法
export function getPageUrl(config, router) {
  /* 特殊判断sr
       1. 如果没有routerPermissionName，取当前路由的name
       2. 如果有routerPermissionName，判断是否是changeOrderDetail，
                如果是，判断url是否是GetSingleById接口，如果是，判断是否data中包含NewSKU,
                      包含则取routerPermissionName，否则取name
    */

  const docModelList = Object.values(objChangeOrderMap.objDocModel)
  config.headers['page_url'] = router.app._route.name
  if (router.app._route.query && router.app._route.name === 'changeOrderDetail' && router.app._route.query.routerPermissionName) {
    if (config.url.includes('Query/GetSingleById')) {
      config.headers['page_url'] = (config.data && docModelList.includes(config.data.docModel)) ? router.app._route.query.routerPermissionName : router.app._route.name
    } else {
      config.headers['page_url'] = router.app._route.query.routerPermissionName
    }
  }
}
